import Keycloak from 'keycloak-js'
import { config } from './config'
import * as Sentry from '@/core/sentry'
import { isProduction, isMyEasybellCom, getEKPUrl } from '@/utils/environment'
import { storage } from '@/utils/storage/storage'

const keycloak = new Keycloak({
  url: isMyEasybellCom()
    ? config.AUTHENTICATON.keycloak.urlEasybellCom
    : config.AUTHENTICATON.keycloak.urlEasybellDe,
  realm: config.AUTHENTICATON.keycloak.realm,
  clientId: config.AUTHENTICATON.keycloak.clientId,
})

export async function loginKeycloak() {
  try {
    const authenticated = await keycloak.init({
      onLoad: 'login-required',
      pkceMethod: 'S256',
      checkLoginIframe: false,
    })

    if (!authenticated) {
      throw new Error('Keycloak did not authenticate')
    }

    return keycloak.token
  } catch (error) {
    // DEBUG: remove when we know it's working
    if (!isProduction()) {
      // eslint-disable-next-line no-console
      console.error(error)
    }

    Sentry.captureException(error)
  }
}

export async function loginKeycloakSso() {
  try {
    const authenticated = await keycloak.init({
      onLoad: 'check-sso',
      silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
      pkceMethod: 'S256',
      checkLoginIframe: false,
    })

    if (!authenticated) {
      return undefined
    }

    return keycloak.token
  } catch (error) {
    Sentry.captureException(error)
  }
}

export function redirectToKeycloakLogin() {
  keycloak.login()
}

export async function refreshKeycloakToken() {
  await keycloak.updateToken(-1)

  return keycloak.token
}

export function logoutKeycloak() {
  keycloak.logout({ redirectUri: `${getEKPUrl()}/logout` })
}

export function isKeycloakUsed() {
  const hasLoginWithKeycloakParam =
    new URLSearchParams(window.location.search).get('loginWith') === 'keycloak'

  const wasLoggedInWithKeycloak = storage.authMode === 'keycloak'

  return hasLoginWithKeycloakParam || wasLoggedInWithKeycloak
}
